export default "__VITE_ASSET__e54b2f02__"